export default __webpack_public_path__ + "static/media/028-nuclear energy.f5cf1533.svg";